const FRIENDLY_SERVER_ERROR =
  'Não foi possível concluir esta operação neste momento. Tente novamente mais tarde. Se o problema persistir, contacte o suporte.';

const TECHNICAL_ERROR_PATTERN =
  /(SQLSTATE|SQL:|unknown column|syntax error|stack trace|exception\b|vendor\\|vendor\/)/i;

// Pedidos de autenticação tratam o 401 no próprio formulário (ex.: credenciais inválidas)
const AUTH_FLOW_PATTERN = /\/auth\/(login|google-login|logout|register|forgot-password|reset-password)/;

let redirectingToLogin = false;

async function redirectToLogin() {
  if (redirectingToLogin) return;
  redirectingToLogin = true;
  // Imports dinâmicos: router e store importam (indirectamente) este ficheiro
  const [{ default: router }, { default: store }, { removeToken }] = await Promise.all([
    import('@/router'),
    import('@/vuex/store'),
    import('@/utils/tokenStorage'),
  ]);
  removeToken();
  store.commit('auth/CLEAR_AUTH_DATA');
  try {
    if (router.currentRoute.value.name !== 'Login') await router.replace({ name: 'Login' });
  } finally {
    redirectingToLogin = false;
  }
}

export default function apiErrorHandler(error) {
  if (error.response?.status === 401 && !AUTH_FLOW_PATTERN.test(error.config?.url || '')) {
    redirectToLogin();
    // Sessão expirada: não propagar o erro, para os componentes não exibirem alertas
    return new Promise(() => {});
  }

  if (error.response) {
    const responseData = error.response.data;
    const message = typeof responseData?.message === 'string' ? responseData.message : '';
    const isServerError = error.response.status >= 500;

    if (isServerError || TECHNICAL_ERROR_PATTERN.test(message)) {
      error.response.data = {
        ...(responseData && typeof responseData === 'object' ? responseData : {}),
        message: FRIENDLY_SERVER_ERROR,
      };
    }
  }

  return Promise.reject(error);
}
